'use es6';
/**
 * TODO: Is there a better way to do this?
 * TODO: Add to `CodeMirror.commands`?
 *
 * Gets all fold indices from the passed codemirror instance in reverse order.
 * Calling `foldCode()` on folds in reverse order won't break nested folds.
 *
 * Assumes folds have been added to codemirror.
 * Use the `@foldGutter` decorator to do so.
 *
 * @param  {CodeMirror} codemirror  CodeMirror editor instance.
 * @return {Array.<UInt>}           Array of line indices that are folded. Reverse order.
 */

export function getAllFoldIndices(codemirror) {
  const folds = []; // Identify folds via marks.

  const marks = codemirror.getAllMarks();

  if (!marks.length) {
    return folds;
  } // Get all folded lines from marks in reverse order.


  const foldedLines = marks.reduceRight((coll, mark) => {
    // TODO: `__isFold` may be unreliable in future versions.
    const isFoldMarker = mark.__isFold || mark.replacedWith && mark.replacedWith.classList.contains('CodeMirror-foldmarker');
    const line = isFoldMarker && mark.lines[0];

    if (line) {
      coll.push(line);
    }

    return coll;
  }, []); // Get the line index for the matching line by reverse iterating over every line.

  const foldedLinesLength = foldedLines.length;

  if (!foldedLinesLength) {
    return folds;
  }

  for (let lineIdx = codemirror.lastLine(), foldIdx = 0; lineIdx-- && foldIdx < foldedLinesLength;) {
    const line = codemirror.getLineHandle(lineIdx);

    if (line === foldedLines[foldIdx]) {
      folds.push(lineIdx);
      ++foldIdx;
    }
  }

  return folds;
}